module.exports = __webpack_public_path__ + "static/media/radio.9b6aab30.svg";